import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import Icon from '../../icons'
import { themeQuartz } from 'ag-grid-community'
import { trackEvent } from '../../../_common/functions'

interface TableProps {
    engineResponse: any
}

const Table: React.FC<TableProps> = ({ engineResponse }) => {
    const [columnDefs, setColumnDefs] = useState<any>(null)
    const [rowData, setRowData] = useState<any>(null)

    const myTheme = themeQuartz.withParams({
        backgroundColor: '#fff',
        headerFontWeight: '600',
        headerFontSize: '0.75rem',
        headerTextColor: '#222222',
        headerBackgroundColor: '#F5E003',
        oddRowBackgroundColor: '#ff6600',
    })

    const downloadCSV = (filename: string, rows: any[]) => {
        if (!rows || rows.length === 0) return

        const headers = Object.keys(rows[0])

        const csvContent =
            headers.join(',') +
            '\n' +
            rows
                .map((row) =>
                    headers
                        .map((field) => {
                            const value = row[field] ?? ''
                            return `"${String(value).replaceAll('"', '""')}"` // escape quotes
                        })
                        .join(','),
                )
                .join('\n')

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        link.click()

        URL.revokeObjectURL(url)
    }

    useEffect(() => {
        if (engineResponse?.sql_result?.length) {
            setColumnDefs(
                Object.keys(engineResponse.sql_result[0]).map((colName: string, i: number) => {
                    const col: any = {
                        field: colName,
                        headerName: colName,
                        minWidth: 150,
                        cellStyle: {
                            paddingLeft: 10,
                            paddingRight: 10,
                            textAlign: 'center',
                        },
                    }
                    if (i == 0) {
                        col.pinned = 'left'
                    }
                    return col
                }),
            )

            setRowData(engineResponse.sql_result)
        }
    }, [engineResponse])

    if (engineResponse?.sql_result?.length) {
        return (
            <div className="relative text-[0.583rem]" style={{ ['--ag-font-size' as any]: '0.667rem' }}>
                <Icon
                    name="download"
                    className="absolute z-50 right-[0.3rem] top-[0.3rem] opacity-30 hover:opacity-100"
                    onClick={() => {
                        trackEvent('ai_insight_table_csv_downloaded', { row_count: rowData?.length ?? 0, filename: 'test-ops.download.csv' })
                        downloadCSV('test-ops.download.csv', rowData)
                    }}
                />
                {columnDefs && rowData && (
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        domLayout="autoHeight"
                        defaultColDef={{
                            headerClass: 'ag-left-aligned-header',
                        }}
                        headerHeight={24}
                        rowHeight={28}
                        theme={myTheme}
                    />
                )}
            </div>
        )
    } else {
        return null
    }
}

export default Table
